<ng-particles
  id="tsparticles"
  [options]="confettiOptions"
  [particlesInit]="particlesInit"
  *ngIf="particlesVisible"></ng-particles>
